<template>
  <div
    class="modal fade"
    id="unsupportedBrowserModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="unsupportedBrowserModal"
    aria-hidden="true"
    data-backdrop="static" data-keyboard="false"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title"  v-html="title"></h3>
        </div>
        <div class="modal-body">
          <b v-html="content"></b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import $ from "jquery";

export default {
    name: "UnsupportedBrowserModal",
    data() {
        return {
            title: null,
            content: null
        }
    },
    mounted() {
      ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.OPEN_UNSUPPORTED_BROWSER_MODAL, (params) => {
            this.show(params);
        });
    },
    methods: {
        show(params) {
            this.title = params.title;
            this.content = params.content;
            $("#unsupportedBrowserModal").modal("show");
        }
    },
};
</script>

<style scoped>
  .modal-dialog {
    max-width: 600px;
  }
</style>
